import { create } from "zustand";

interface ContentState {
  activeLocale: "tr" | "en";
  dirty: boolean;
  setActiveLocale: (locale: "tr" | "en") => void;
  setDirty: (dirty: boolean) => void;
}

export const useContentStore = create<ContentState>()((set) => ({
  activeLocale: "tr",
  dirty: false,
  setActiveLocale: (activeLocale) => set({ activeLocale }),
  setDirty: (dirty) => set({ dirty }),
}));
